import {useMutation} from '@apollo/react-hooks';

import type {
    CreateEmailSequence as CreateEmailSequenceMutation,
    CreateEmailSequenceVariables as CreateEmailSequenceMutationVariables,
    EmailSequenceCreateInput,
} from 'nutshell-graphql-types';

import CREATE_EMAIL_SEQUENCE from '../mutations/create-email-sequence.graphql';

export function useCreateEmailSequence(): {
    createEmailSequence: (arg1: EmailSequenceCreateInput) => Promise<any>;
    isCreating: boolean;
    hasCreated: boolean;
} {
    const [createEmailSequence, {loading, called}] = useMutation<
        CreateEmailSequenceMutation,
        CreateEmailSequenceMutationVariables
    >(CREATE_EMAIL_SEQUENCE);

    return {
        createEmailSequence: (input: EmailSequenceCreateInput) =>
            createEmailSequence({
                variables: {
                    emailSequence: input,
                },
            }),
        isCreating: loading,
        hasCreated: called,
    };
}
